// ローン種類選択
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { handleBrowserBack } from '../../BrowserBack';
import Heading from '../../molecules/Heading';
import { Container } from 'react-bootstrap';
import LoanSelect from '../../molecules/LoanSelect';
import TransitionButton from '../../molecules/TransitionButton';
import axios from 'axios';
import { loan_info } from '../../Const';
import LoadingModal from '../../molecules/LoadingModal';

interface Items {
  name: string;
  text: string;
  type: string;
  loan_type_cd: string;
  is_new_line: boolean;
}
const FundUseSelection: React.FC = () => {
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const jacode = url_params.get('jacode') ?? undefined;
  const [items, setItems] = useState<Items[]>([]);
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(true);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 表示するローン種類を取得する
    getItems();
  }, []);

  const getItems = async () => {
    try {
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/get_items`, { ja_code: jacode });
      response.data.map((loan_type_cd: string) => {
        // 取得したローン種類コードと一致する情報を定数から取得
        const loan = loan_info.find(loan => loan.loan_type_cd === loan_type_cd);
        if (loan === undefined) {
          return;
        }
        setItems(prev => [...prev, loan]);
      });
    } catch (error) {
      console.error(error);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // マイページへ戻るボタン押下
  const transitionMypage = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`);
  };

  // お申込はこちらのボタンを押下した時
  const applicationButtonClick = async (ja_code: string | undefined, loan_type_cd: string) => {
    try {
      setIsLoading(true);
      location.replace(
        `${location.origin}${process.env.MIX_MOCK_URL}/agreement_personal_info?jacode=${ja_code}&r_type_id=2&loan_type_cd=${loan_type_cd}`
      );
    } catch (error) {
      console.error(error);
      alert(error.response.data.message);
      setIsLoading(false);
    }
  };

  return (
    <>
      <Heading label="お申込みローンの選択" size="l" />
      <Container>
        <div className="container-box">
          <div className="p-lead">
            お申込みされたいローンをご選択下さい。
            <br />
            商品詳細はネットローンHPもしくは、お取引JAにご確認下さい。
          </div>
          <div className="loan-box">
            {items.map((item, index) => {
              return (
                <LoanSelect
                  name={item.name}
                  text={item.text}
                  type={item.type}
                  key={index}
                  is_new_line={item.is_new_line}
                  application_btn_func={() => applicationButtonClick(jacode, item.loan_type_cd)}
                />
              );
            })}
          </div>
          <TransitionButton
            label="マイページへ戻る"
            btn_class="two_lines"
            handleClick={transitionMypage}
          />
        </div>
      </Container>
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('fund-use-selection')) {
  render(<FundUseSelection />, document.getElementById('fund-use-selection'));
}
